import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { symbol: String }

  activate() {
    if (this.loaded) return
    this.loaded = true

    const config = {
      symbol: this.symbolValue,
      theme: "dark",
      style: "1",
      interval: "60",
      timezone: "Etc/UTC",
      autosize: true,
      hide_side_toolbar: false,
      allow_symbol_change: false,
      support_host: "https://www.tradingview.com"
    }

    const script = document.createElement("script")
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js"
    script.async = true
    script.innerHTML = JSON.stringify(config)

    this.containerTarget.appendChild(script)
  }
}
